export default {
  namespaced: true,
  state: {
    productIndex: 1,
    products: [],
    cartItems: [],
    itemIndex: 1,
  },
  getters: {
    getItemIndex: state => {
      return (
        state.itemIndex
      )
    },
    isProductExists: state => kode => {
      return (
        state.products.length && state.products.find(prod => prod.kode == kode)
      )
    },
    isItemExists: state => (kode, id) => {
      return state.products.find(prod => {
        if (prod.kode == kode) {
          return prod.items.find(item => item.id == id)
        }
      })
    },
    totalPrice: state => {
      let sum = 0
      state.products.forEach(product => {
        product.items.forEach(item => {
          let price = item.qty * item.price
          sum += price
        })
      })
      return sum
    },
    totalPriceItem: state => kode => {
      let sum = 0
      state.cartItems.forEach(item => {
        let price = item.qty * item.price
        sum += price
      })
      return sum
    },
  },
  mutations: {
    ADD_PRODUCT(state, product) {
      state.products.push(product)
      state.productIndex++
    },
    ADD_ITEM(state, cartItem) {
      state.cartItems.push(cartItem)
      state.itemIndex++
    },
    ADD_TYPE(state, item) {
      const appendItem = state.products.map(prod => {
        if(prod.INDEX == item.prod_id){
          prod.COUNT += 1
          if(prod.TYPE.some(type => type.name == item.type) == false){
            var arr = {}
            arr['count'] = 1
            arr['name'] = item.type
            arr['price'] = item.price*item.qty
            prod.TYPE.push(arr)
            prod.TOTAL = prod.TOTAL + item.price*item.qty
            return prod
          }else{
            prod.TYPE.map((val,key) => {
              if(val['name'] == item.type){
                val['count'] = val['count'] + 1
                val['price'] = val['price'] + item.price*item.qty
              }
            })
            prod.TOTAL = prod.TOTAL + item.price*item.qty
            return prod
          }
        }else{
          return prod
        }
      })

      state.products = appendItem
    },
    PUSH_ITEM(state, { kode, item }) {
      const appendItem = state.products.map(prod => {
        if (prod.kode == kode) {
          prod.items.push(item)
          return prod
        } else {
          return prod
        }
      })
      state.products = appendItem
    },
    PUSH_QTY(state, { kode, item }) {
      const { id, qty } = item
      const appendQty = state.products.map(prod => {
        if (prod.kode == kode) {
          prod.items.map(it => {
            if (it.id == id) {
              it.qty = it.qty + qty
              return it
            } else {
              return it
            }
          })
          return prod
        } else {
          return prod
        }
      })

      state.products = appendQty
    },
    REMOVE_ITEM(state, itemId) {
      const removeItem = state.products.map(prod => {
        let currentProd = prod
        let removedItems = prod.items.filter(itemProd => {
          return itemProd.id != itemId
        })
        currentProd.items = removedItems
        if (currentProd.items.length) {
          return currentProd
        }
      })

      state.products = removeItem.filter(prod => prod !== undefined)
    },
    DELETE_ITEM(state, itemId) {
      let check = state.cartItems.find(item => {
        return item.index == itemId
      })

      state.products.forEach(element => {
        if(element.INDEX == check.prod_id){
          element.TYPE.forEach(prodtype => {
            if(prodtype.name == check.type){
              prodtype.price -= (check.price * check.qty)
              prodtype.count -= 1
              element.COUNT -= 1
              element.TOTAL -= (check.price * check.qty)
            }
          });
        }
      });

      state.cartItems = state.cartItems.filter(item => {
        return item.index -= itemId
      })
    },
    EMPTY_ITEM(state) {
      state.cartItems = []
    },
    CLEAR_ALL(state) {
      state.products = []
    }
  },
  actions: {
    addProduct({ commit,state }, product) {
      commit('ADD_PRODUCT', product)
    },
    addItems({ commit, getters }, cartItem) {
      console.log('OLA', cartItem)
      const objItem = {
        kode : cartItem.kode,
        root : cartItem.root,
        prod_id : cartItem.prod_id,
        name : cartItem.name,
        item_name : cartItem.item_name,
        qty : cartItem.qty,
        price : cartItem.price,
        type : cartItem.type,
      }
      objItem.index = getters.getItemIndex
      commit('ADD_ITEM', objItem)
      commit('ADD_TYPE', cartItem)
    },
    clearItem({ commit }, itemId) {
      commit('DELETE_ITEM', itemId)
    },
    clearAllItem({ commit }) {
      commit('EMPTY_ITEM')
    },
    clearAllProduct({ commit }){
      commit('EMPTY_ITEM')
      commit('CLEAR_ALL')
    }
  },
}
